// import axios from "axios";
import { api, authorizationKey, BASE_URL } from "./BASE_URL";

export const fetchPipelines = async () => {
  try {
    const response = await api.get(`${BASE_URL}/admin/pipelines`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    const formattedResponse = response.data.map((pipeline) => {
      return { ...pipeline, leads: [] };
    });
    return formattedResponse;
  } catch (err) {
    if (err.message === "canceled") {
      return;
    }
    console.error("Error fetching pipelines:", err);
    throw err;
  }
};

export const fetchLeads = async (pipelineId, cursor, searchQuery, count) => {
  const url = new URL(`${BASE_URL}/admin/pipelines/${pipelineId}`);

  const params = new URLSearchParams();

  if (cursor) params.append("cursor", cursor);
  if (searchQuery) {
    new URLSearchParams(searchQuery).forEach((value, key) => {
      params.append(key, value);
    });
  }
  if (count) params.append("count", count);

  url.search = params.toString();
  try {
    const response = await api.get(url, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    if (err.message === "canceled") {
      return;
    }
    console.error("Error fetching leads for pipeline:", err);
    throw err;
  }
};

export const postPipeline = async (pipelineData) => {
  try {
    const response = await api.post(
      `${BASE_URL}/admin/pipelines`,
      pipelineData,
      {
        headers: {
          Authorization: authorizationKey,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error("Error posting pipeline:", err);
    throw err;
  }
};

export const updateDraggedLead = async ({ targetPipelineId, leadId }) => {
  const payload = {
    pipeline_id: targetPipelineId,
  };
  try {
    const response = await api.put(
      `${BASE_URL}/admin/leads/${leadId}`,
      payload,
      {
        headers: {
          Authorization: authorizationKey,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error("Error updating dragged lead reminder:", err);
    throw err;
  }
};

export const getLeadData = async (id) => {
  try {
    const response = await api.get(`${BASE_URL}/admin/leads/${id}`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error(
      `There was an error getting lead's data from the server: ${err}`,
    );
    throw err;
  }
};

export const getTags = async () => {
  try {
    const response = await api.get(`${BASE_URL}/admin/tags`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error(`There was an error getting tags from the server: ${err}`);
    throw err;
  }
};

export const postTagForLead = async ({ tagId, leadId }) => {
  try {
    const response = await api.post(
      `${BASE_URL}/admin/lead/${leadId}/tags`,
      {
        tag_ids: [tagId],
      },
      {
        headers: {
          Authorization: authorizationKey,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error("Error posting tag:", err);
    throw err;
  }
};

export const removeTag = async ({ leadId, tagId }) => {
  try {
    const response = await api.delete(
      `${BASE_URL}/admin/lead/${leadId}/tags/${tagId}`,
      {
        headers: {
          Authorization: authorizationKey,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error("There was an error removing the tag", err);
    throw err;
  }
};

export const updateLead = async ({ payload, leadId }) => {
  try {
    const response = await api.put(
      `${BASE_URL}/admin/leads/${leadId}`,
      payload,
      {
        headers: {
          Authorization: authorizationKey,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error("Error updating dragged lead:", err);
    throw err;
  }
};

export const postTag = async (tag) => {
  try {
    const response = await api.post(
      `${BASE_URL}/admin/tags`,
      {
        name: tag,
      },
      {
        headers: {
          Authorization: authorizationKey,
        },
      },
    );
    return response.data;
  } catch (err) {
    console.error("Error posting tag:", err);
    throw err;
  }
};

export const postNote = async ({ description, lead_id }) => {
  const payload = { description, lead_id };
  try {
    const response = await api.post(`${BASE_URL}/admin/notes`, payload, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error posting note:", err);
    throw err;
  }
};
export const postContactLeads = async (contact) => {
  try {
    const response = await api.post(`${BASE_URL}/admin/contacts`, contact, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error posting contact:", err);
    throw err;
  }
};
export const getOnlineInfo = async (leadID) => {
  try {
    const response = await api.get(`${BASE_URL}/admin/live-info?id=${leadID}`, {
      headers: {
        Authorization: authorizationKey,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error getting live info: ", err);
    throw err;
  }
};
